<template>
    <section style="padding-left: 1em; padding-right: 1em; ">

        <b-row>
            <b-col v-for="(patientStats, i) in patientStatistics" :key="i" md="4">
                <div 
                :class="patientStats.customClass" 
                style="width: 100%; border: 0.8px solid rgba(0, 0, 0, 0.2); border-radius: 14px; padding:0.2em"
                >
                    <div 
                        class="d-flex align-items-center justify-content-between" 
                        style="padding: 0.4em;"
                        >
                        <div>
                            <UserIcons :key="patientStats.icon" :icon-type="patientStats.icon" />
                        </div>

                        <div style="text-align: right;">
                           <div style="font-size: 14px; line-height: 19.1px;">{{ patientStats.label }}</div> 
                           <div class="text-dark" style="font-weight: 600; font-size: 14px; line-height: 19.1px; color:#000">{{ patientStats.value }}</div>

                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

    </section>
  </template>
  
  <script>
  import UserIcons from "@/pages/main/home/UserIcons.vue";
  import {
  BAvatar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol, BMedia, BMediaAside,
  BMediaBody,
  BRow,
  } from 'bootstrap-vue';
  
  export default {
    components: {
      UserIcons,
      BRow,
      BCol,
      BCard,
      BCardHeader,
      BCardTitle,
      BCardText,
      BCardBody,
      BMedia,
      BAvatar,
      BMediaAside,
      BMediaBody,
    },
    props: {
      patientStatistics: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: ""
      }
    },
  }
  </script>
  
  
  <style lang="scss">

  </style>
